import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { NotFoundScreen } from '@/common/ErrorScreen';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import CoordinatorFollowUpsTable from '@/tables/CoordinatorFollowUpsTable';
import PartnerFollowUpsTable from '@/tables/PartnerFollowUpsTable';
import { useCurrentUser } from '~/hooks/useCurrentUser';
import { PageContainer } from '~/styles/boardStyles';
import { GroupHeaderWrapper } from '~/styles/layoutElements';

export const Route = createFileRoute('/_app/follow-ups/entries/')({
  component: FollowUpEntriesScreen,
});

/**
 * The Follow-ups subnav of both follow-up portals.
 *
 * The two tables are one query with two scopes; they're separate components
 * because the endpoints publish two schemas. No Create Follow-up button:
 * legacy's is switched off.
 */
function FollowUpEntriesScreen() {
  const { t } = useTranslation();
  const { me, isPending } = useCurrentUser();

  const isCoordinator = me?.profile_type === 'FOLLOWUP_COORDINATOR';
  const isPartner = me?.profile_type === 'FOLLOWUP_PARTNER';

  // No admin arm, as on the pending requests route.
  if (isPending) return null;
  if (!isCoordinator && !isPartner) return <NotFoundScreen />;

  return (
    <PageContainer>
      <GroupHeaderWrapper>
        {/* One heading, with the help placement chosen by the caller's
           role. */}
        <TitleWithQuestion
          title={t('wbs.follow-ups')}
          placement={
            isCoordinator
              ? 'follow_up_for_coordinators'
              : isPartner
                ? 'follow_up_for_partners'
                : undefined
          }
        />
      </GroupHeaderWrapper>
      {isCoordinator ? (
        <CoordinatorFollowUpsTable />
      ) : (
        <PartnerFollowUpsTable />
      )}
    </PageContainer>
  );
}
